<div class="row mb-2" *ngIf="(global.globalAgencyId!=null && global.globalAgencyId!=undefined  &&
global.globalAgencyId!=''&& global.globalAgencyId!='00000000-0000-0000-0000-000000000000')">
  <div class="col pl-0">
    <div widget class="card border-0 box-shadow">
      <div class="card-header transparent  text-muted">
        <h4 class="mb-0 font-header">Budget Import</h4>
      </div>
      <div class="card-body  widget-body pb-0 pt-2 mb-4">
        <div class="row">
          <div class="col-12 d-flex">
            <div>
              <button type="button" class="btn btn-sm " data-bs-toggle="modal" data-bs-target="#viewbasicadvance" *ngIf="this.global.LoginEntityType !='CLIENT'"
                (click)="BudgetCreateupdate()" [disabled]="global.viewTabs">Import Budget</button>

              <button type="button" class="btn btn-sm ms-3" data-bs-toggle="modal" data-bs-target="reportFilter"
                [disabled]="global.viewTabs" (click)="reportPopup()">Utilization Report</button>
            </div>
            <div class="d-flex col-3 ms-2" *ngIf="bugetInput.clientId == '00000000-0000-0000-0000-000000000000' || 
              bugetInput.clientId == undefined || bugetInput.clientId == null">
              <label class="m-2">Client</label>
              <!-- </div>
            <div *ngIf="bugetInput.clientId == '00000000-0000-0000-0000-000000000000' || 
              bugetInput.clientId == undefined || bugetInput.clientId == null"> -->
              <ng-select class="w-100" [(ngModel)]="filterbo.clientId" [searchable]="true"
                [disabled]="global.isViewClientBudget || global.globalAgencyId == null || global.globalAgencyId == '00000000-0000-0000-0000-000000000000' || global.globalAgencyId == '' || this.global.LoginEntityType =='CLIENT'"
                [clearable]="true" [items]="allClientDropDown" bindLabel="clientName" bindValue="id">
              </ng-select>
            </div>
            <div class="d-flex ms-3">
              <input type="radio" class="ml-2" name="status" [value]="'Active'" [(ngModel)]="status"
                [disabled]="global.viewTabs" (change)="statusChangeCall('Active')" /> &nbsp;
              <label class="padding">Active &nbsp;</label>
              <input type="radio" class="ml-2" name="status" [value]="'All'" [(ngModel)]="status"
                [disabled]="global.viewTabs" (change)="statusChangeCall('All')" /> &nbsp;
              <label class="padding">All &nbsp;</label>
              <!-- </div>
              <div class="b5" > -->
              <input type="radio" class="ml-2" name="status" [value]="'Expired'" [(ngModel)]="status"
                [disabled]="global.viewTabs" (change)="statusChangeCall('Expired')" /> &nbsp;
              <label class="padding">Expired &nbsp;</label>
              <input type="radio" class="ml-2" name="status" [value]="'InActive'" [(ngModel)]="status"
                [disabled]="global.viewTabs" (change)="statusChangeCall('InActive')" /> &nbsp;
              <label class="padding">InActive &nbsp;</label>
            </div>
            <div class="ms-auto">
              <button type="button" class="btn btn-sm" (click)="getOnBoardFilter()" *ngIf="bugetInput.clientId == '00000000-0000-0000-0000-000000000000' || 
              bugetInput.clientId == undefined || bugetInput.clientId == null"
                [disabled]="this.global.isViewClientBudget || global.globalAgencyId == null || global.globalAgencyId == '00000000-0000-0000-0000-000000000000' || global.globalAgencyId == ''">
                Apply
              </button>
              <!-- </div> -->
              <!-- <div> -->
              <button type="button" class="btn btn-sm ms-3" (click)="refresh()"
                [disabled]="this.global.isViewClientBudget || global.globalAgencyId == null || global.globalAgencyId == '00000000-0000-0000-0000-000000000000' || global.globalAgencyId == '' || global.viewTabs">
                <i class="fa fa-repeat"> </i>Refresh
              </button>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</div>
<!-- ////////////////////////////////////////////////////////////////////////////// -->

<!-- /////////////////////////////////////////////////////////////////// -->
<div class="row mb-2" *ngIf="(global.globalAgencyId!=null && global.globalAgencyId!=undefined  &&
  global.globalAgencyId!=''&& global.globalAgencyId!='00000000-0000-0000-0000-000000000000')">
  <div class="col pl-0">
    <div widget class="card border-0 box-shadow">
      <div class="card-body  widget-body pt-2">
        <ejs-grid #grid [dataSource]='dataOnBoardclient | async' [allowResizing]='true' [allowSorting]='true'
          allowPaging='true' [allowFiltering]='true' [pageSettings]='initialPage' [filterSettings]='filterOptions'
          [showColumnChooser]='true' (dataStateChange)="datachangeonBoardEmp($event)"
          (actionBegin)="OnBoardActionComplete($event)">
          <e-columns>
            <e-column minWidth=100 uid="action" headerText="Actions" textAlign="center" [showInColumnChooser]='false'>
              <ng-template #template let-data>
                <i class="fa fa-eye me-3" style="color:#502189;font-size:15px;" (click)="editbudget(data)"
                  data-bs-toggle="modal" data-bs-target="#Editbasicadvance"></i>
                <i class="fa fa-history" style="color:#502189;font-size:15px;" data-bs-target="#typelistmodalopen"
                  data-bs-toggle="modal" (click)="GetBudgetLog(data)"></i>
              </ng-template>
            </e-column>

            <e-column minWidth=100 field="budgetStartDate" headerText="Budget Start Date" type="date"
              [format]="formatOptions">
              <!-- <ng-template #filterTemplate let-data>
                <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
              </ng-template> -->
            </e-column>
            <e-column minWidth=100 field="budgetEndDate" headerText="Budget End Date" type="date"
              [format]="formatOptions">
              <!-- <ng-template #filterTemplate let-data>
                <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
              </ng-template> -->
            </e-column>
            <e-column minWidth=100 field="clientName" headerText="Client Name" type="string">
              <ng-template #filterTemplate let-data>
                <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
              </ng-template>
            </e-column>
            <e-column minWidth=100 field="budgetStatus" headerText="Budget Status" type="string">
              <ng-template #filterTemplate let-data>
                <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
              </ng-template>
            </e-column>
            <e-column minWidth=100 field="insuranceNo" headerText="Insurance Number" type="string">
              <ng-template #filterTemplate let-data>
                <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
              </ng-template>
            </e-column>
            <e-column minWidth=100 field="totalAmt" headerText="Total Amount" type="number">
              <ng-template #filterTemplate let-data>
                <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
              </ng-template>
            </e-column>
            <e-column minWidth=100 field="unusedAmt" headerText="Unused Amount" type="number" [allowFiltering]="false" [allowSorting]="false">
              <ng-template #filterTemplate let-data>
                <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
              </ng-template>
            </e-column>
            <e-column minWidth=100 field="lastupdateddate" headerText="Last modified Date" type="date" [allowFiltering]="false"
              [format]="formatOptions">
              <ng-template #filterTemplate let-data>
                <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
              </ng-template>
            </e-column>

            <!--------------------------------table header icon---------------->
            <e-column width="50" [showInColumnChooser]='false'>
              <ng-template #headerTemplate let-data>
                <div>
                  <span id='show'><i class="fa fa-cog fa-lg" aria-hidden="true">
                    </i>
                  </span>
                </div>
              </ng-template>
            </e-column>
          </e-columns>
        </ejs-grid>
      </div>
    </div>
  </div>
</div>

<span id="OpenreportFilter" data-bs-target="#reportFilter" data-bs-toggle="modal"></span>
<div class="modal fade modalbackgrod" id="reportFilter" data-bs-backdrop="static">
  <div class="modal-dialog Utilization-popup" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title font-header">Utilization Report</h5>
      </div>
      <div class="modal-body">
        <div *ngIf="this.global.LoginUserType != 'Onboard'">
          <div class="row" *ngIf="(bugetInput.clientId == '00000000-0000-0000-0000-000000000000' || 
            bugetInput.clientId == undefined || bugetInput.clientId == null )">
            <div class="col-lg-6">
              <label>Select Client</label>
            </div>
            <div class="col-lg-6">
              <ng-select [(ngModel)]="reportClientId" [searchable]="true"
                [disabled]="global.isViewClientBudget || global.globalAgencyId == null || global.globalAgencyId == '00000000-0000-0000-0000-000000000000' || global.globalAgencyId == ''"
                [clearable]="true" [items]="allClientDropDown" bindLabel="clientName"
                (ngModelChange)="getAllBudgetsForClient()" bindValue="id">
              </ng-select>
            </div>
          </div>
        </div>

        <div class="row mb-2">
          <div class="col-lg-6">
            <label>Select Budget</label>
          </div>
          <div class="col-lg-6">
            <ng-select [(ngModel)]="selectedBudgetId" [searchable]="true" [clearable]="true" [items]="allBudgetDropDown"
              bindLabel="Value" bindValue="Key">
            </ng-select>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-6">
            <label>Report Type</label>
          </div>
          <div class="col-lg-6">

  <!-- Row 1 -->
  <div class="d-flex align-items-center gap-3">
    <div>
      <input type="radio"
             [(ngModel)]="ReportType"
             name="reportType"
             value="detail"
             (change)="onDetailSummaryChange('detail')" />
      <label class="ms-1">Detailed</label>
    </div>

    <ng-container *ngIf="ReportType !== 'summary'">
      <div>
        <input type="checkbox"
               [(ngModel)]="isDaily"
               (change)="onDailyChange()" />
        <label class="ms-1">Daily</label>
      </div>

      <div>
        <input type="checkbox"
               [(ngModel)]="isWeekly"
               (change)="onWeeklyChange()" />
        <label class="ms-1">Weekly</label>
      </div>
    </ng-container>
  </div>

  <!-- Row 2 -->
  <div class="mt-2">
    <input type="radio"
           [(ngModel)]="ReportType"
           name="reportType"
           value="summary"
           (change)="onDetailSummaryChange('summary')" />
    <label class="ms-1">Summary</label>
  </div>

</div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button"
          *ngIf="this.global.LoginUserType != 'Onboard' && bugetInput.clientId != '00000000-0000-0000-0000-000000000000' "
          class="btn blue-btn btn-sm" [disabled]="(selectedBudgetId == null || selectedBudgetId == undefined)"
          (click)="showReport()">Generate Report</button>
        <button type="button"
          *ngIf="this.global.LoginUserType != 'Onboard' && bugetInput.clientId == '00000000-0000-0000-0000-000000000000'"
          class="btn blue-btn btn-sm"
          [disabled]="(selectedBudgetId == null || selectedBudgetId == undefined || reportClientId == null || reportClientId == undefined) "
          (click)="showReport()">Generate Report</button>
        <button type="button" *ngIf="this.global.LoginUserType == 'Onboard'" class="btn blue-btn btn-sm"
          [disabled]="(selectedBudgetId == null || selectedBudgetId == undefined)" (click)="showReport()">Generate
          Report</button>
        <button type="button" class="btn blue-btn btn-sm" data-bs-dismiss="modal">Cancel</button>
      </div>
    </div>
  </div>
</div>

<span id="openReportModal" data-bs-target="#viewReport" data-bs-toggle="modal"></span>
<div class="modal fade modalbackgrod" id="viewReport" data-bs-backdrop="static">
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title font-header">Utilization Report</h5>
        <div class="text-right">
          <button class="btn blue-btn btn-sm mr-2" (click)="closemodal()">
            Close</button>
        </div>
      </div>
      <div class="modal-body" style="height:600px">
        <ng-container *ngIf="reportcontain== true">
          <div style="width: 100%;height:100%" #reportContainer></div>
        </ng-container>
      </div>
      <div class="modal-footer">
      </div>
    </div>
  </div>
</div>

<!--slect Agency message-->
<div class="row mb-2" *ngIf="global.globalAgencyId==null ||global.globalAgencyId==undefined ||
global.globalAgencyId=='' || global.globalAgencyId=='00000000-0000-0000-0000-000000000000'">
  <div class="col pl-0">
    <div widget class="card border-0 box-shadow">
      <div class="card-body pt-2">
        <div class="text-center text-danger pt-3">
          <label class="font-red " style="font-size: 13px;"><i class="fa fa-info-circle fa-lg mr-1"></i>&nbsp;Select
            agency to view details</label>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- ===========================basic advance  modal ======================================================-->

<span id="BasicAdvanceModal" data-bs-target="#viewbasicadvance" data-bs-toggle="modal"></span>
<div class="modal fade modalbackgrod" id="viewbasicadvance" tabindex="-1" role="dialog"
  aria-labelledby="exampleModalLabel" aria-hidden="true" data-bs-backdrop="static">
  <div class="modal-dialog modal-md" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title font-header">Create</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal">

          <span aria-hidden="true"></span>
        </button>
      </div>

      <div class="row mt-4 ms-2">
        <div class="col-lg-6">
          <input type="radio" data-bs-dismiss="modal" (click)="budgetImport('Basic View');" name="view"
            [(ngModel)]="radioadd">&nbsp;
          <label>Basic View</label>
        </div>
        <div class="col-lg-6">
          <input type="radio" data-bs-dismiss="modal" name="view" [(ngModel)]="radioadd"
            (click)="budgetImport('Advance View')">&nbsp;
          <label>Advance View</label>
        </div>
      </div>

      <div class="modal-footer mt-4">
      </div>
    </div>
  </div>
</div>

<span id="BasicAdvanceModal" data-bs-target="#Editbasicadvance" data-bs-toggle="modal"></span>
<div class="modal fade modalbackgrod" id="Editbasicadvance" tabindex="-1" role="dialog"
  aria-labelledby="exampleModalLabel" aria-hidden="true" data-bs-backdrop="static">
  <div class="modal-dialog modal-md" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title font-header">Create</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal">

          <span aria-hidden="true"></span>
        </button>
      </div>

      <div class="row mt-4 ms-2">
        <div class="col-lg-6">
          <input type="radio" [(ngModel)]="radioview" data-bs-dismiss="modal" (click)="type('Basic View');" name="view">
          &nbsp;
          <label>Basic View</label>
        </div>
        <div class="col-lg-6">
          <input type="radio" (click)="type('Advance View')" [(ngModel)]="radioview" data-bs-dismiss="modal"
            name="view">&nbsp;
          <label>Advance View</label>
        </div>
      </div>

      <div class="modal-footer mt-4">
      </div>
    </div>
  </div>
</div>

<!-- .......................................ADD TypeLIST Modal....................................................................... -->
<span id="openaddtypelist" data-bs-target="#typelistmodalopen" data-bs-toggle="modal"></span>
<div class="modal fade modalbackgrod" id="typelistmodalopen" tabindex="-1" role="dialog"
  aria-labelledby="exampleModalLabel" aria-hidden="true" data-bs-backdrop="static">
  <div class="modal-dialog modal-xl" role="document">
    <div class="modal-content">
      <div class="modal-header">

        <h5>Budget Logs</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" (click)="closelog()">

          <span aria-hidden="true"></span>
        </button>
      </div>
      <!-- ..........................................typegrid............ -->
      <div class="row mb-2">
        <div class="col pl-0">
          <div widget class="card border-0 box-shadow">
            <div class="card-body">
              <ejs-grid #gridlog [dataSource]='LogTable' [allowResizing]='true' [allowFiltering]='true'
                [pageSettings]='initialPage1' [filterSettings]='filterOptions' [showColumnChooser]='true'
                [allowSorting]='true' [allowPaging]='true'>
                <e-columns>
                  <e-column minWidth=150 headerText="Activity">
                    <ng-template #template let-data>
                      <div>
                        {{data.loginUsername}}&nbsp;&nbsp;<label><b>Changed
                            on</b></label>&nbsp;&nbsp;{{data.createdDateTime}}
                      </div>
                    </ng-template>
                  </e-column>
                  <e-column minWidth=100 field="attribute_AffectedColumns" headerText="Attribute" type="string">
                    <ng-template #filterTemplate let-data>
                      <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                    </ng-template>
                  </e-column>
                  <e-column minWidth=100 field="oldValue" headerText="Old Value" type="string">
                    <ng-template #filterTemplate let-data>
                      <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                    </ng-template>
                  </e-column>
                  <e-column minWidth=100 field="newValue" headerText="New Value" type="string">
                    <ng-template #filterTemplate let-data>
                      <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                    </ng-template>
                  </e-column>
                </e-columns>
              </ejs-grid>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<app-budgetplan-form *ngIf="BudgetImportData.edit" [budgetImprtPlan]="budgetImprtPlan"
  (dataEmitFromCDCSPlan)="dataEmitFromCDCSPlan($event)" [budgetPlan]="BudgetImportData"
  [BudgetView]="Basic"></app-budgetplan-form>
